import { render, staticRenderFns } from "./Cgu.vue?vue&type=template&id=493aa3b6&scoped=true&"
import script from "./Cgu.vue?vue&type=script&lang=js&"
export * from "./Cgu.vue?vue&type=script&lang=js&"
import style0 from "./Cgu.vue?vue&type=style&index=0&id=493aa3b6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "493aa3b6",
  null
  
)

export default component.exports